// extracted by mini-css-extract-plugin
export default {"container":"style_container__ANQ-p","homy":"style_homy__qR038","home_space":"style_home_space__ofqMM","columnReverse":"style_columnReverse__qzo4g"};